import React, { createContext, useState, useContext } from 'react';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [callsDataCon, setCallsDataCon] = useState([]);
  const [putsDataCon, setPutsDataCon] = useState([]);

  return (
    <DataContext.Provider value={{ callsDataCon, setCallsDataCon, putsDataCon, setPutsDataCon }}>
      {children}
    </DataContext.Provider>
  );
};

export const useDataContext = () => useContext(DataContext);
